import PropTypes from 'prop-types';
import {PiSpinner} from "react-icons/pi";


const Button=({children,className,disabled,size,loading,onClick,type,rounded,theme})=>{
return <button disabled={disabled} type={type} onClick={onClick} className={`new-btn ${size} ${rounded} btn-${theme} ${className}`}>
    {loading ? <PiSpinner className="animate-spin mx-auto" />:children}
</button>
}
Button.propTypes = {

    className: PropTypes.string,
    disabled:PropTypes.bool,
    children: PropTypes.node,
    loading: PropTypes.bool,
    type:PropTypes.oneOf(["submit","button","reset"]),
    onClick:PropTypes.func,
    theme:PropTypes.oneOf(['primary', 'secondary',"danger","success","black","link","light"]),
    rounded:PropTypes.oneOf(["rounded-none","rounded","rounded-sm","rounded-lg","rounded-xl","rounded-full"]),
    size:PropTypes.oneOf(["x-small","small","normal","large"])
}

// Creating default props
Button.defaultProps = {
    className: "",
    children: "",
    loading: false,
    type:"button",
    disabled:false,
    onClick:()=>{},
    theme:"primary",
    rounded:"rounded-none",
    size:"normal"
}
export default Button;